import React from "react";
import { Confirmation } from "../Confirmation/confirmation";
import warning from "../../../static/images/icon-check-danger.png";
import { Button } from "../../primary";
import style from "./ConfirmationModal.module.scss";

const ConfirmationModal = ({ onClose, onConfirm, title = " ", message, confirmBtn = "Yes", closeBtn = "No" }) => {
  return (
    <Confirmation onClose={onClose} title={title}>
      <div className="text-center mx-5">
        <img src={warning} alt="warnning-icon" className="mb-2" />
        <div className="mb-3">{message}</div>
        <div className={style.buttons}>
          <Button classes={{ className: `btn ${style.confirm_btn}` }} onClick={onConfirm}>
            {confirmBtn}
          </Button>
          <Button classes={{ className: `btn ${style.close_btn}` }} onClick={onClose}>
            {closeBtn}
          </Button>
        </div>
      </div>
    </Confirmation>
  );
};

export default ConfirmationModal;
